import { Trans } from '@lingui/react/macro'

import { WellKnownCollection } from '@jotta/grpc-connect-openapi/collection'
import { BrandIcon } from '@jotta/ui/BrandIcon'
import SvgPhotosUploadGray from '@jotta/ui/SvgPhotosUploadGray'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'

import type { TimelineType } from '../PhotoGallery/timelinev2/useTimelineStream'

import styles from './NoTimelinePhotos.module.scss'
export const NoTimelinePhotos = ({ type }: { type: TimelineType }) => {
  switch (type) {
    case WellKnownCollection.TIMELINE:
      return (
        <div className={styles.container}>
          <BrandIcon icon={SvgPhotosUploadGray} className={styles.graySvg} />
          <h2 className={styles.title}>
            <Trans>You have no photos in your library yet!</Trans>
          </h2>
        </div>
      )
    case WellKnownCollection.HIDDEN:
      return (
        <div className={styles.container}>
          <BrandIcon icon={SvgPhotosUploadGray} className={styles.whiteSvg} />
          <div className={styles.wrapper}>
            <h2 className={styles.title}>
              <Trans>You don't have any hidden photos yet!</Trans>
            </h2>
            <p className={styles.subTitle}>
              <Trans>Hidden files will be shown here.</Trans>
            </p>
          </div>
        </div>
      )
    default:
      return exhaustiveGuard(type)
  }
}
